'use client'
import {
  CSSPolyfill,
  CSSReset
} from "./chunk-B4LBJQ3X.mjs";
export {
  CSSPolyfill,
  CSSReset
};
//# sourceMappingURL=index.mjs.map